module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_rates_added":"No rates added yet","rate_description":"Rate Description","add_rate":"Add Rate"},"id":{"no_rates_added":"Belum ada tarif yang ditambahkan","rate_description":"Rincian tarif","add_rate":"Tambah tarif"}}')
  delete Component.options._Ctor
}
